import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel, Flex,
  FormControl,
  FormLabel,
  Textarea,
  useRadioGroup,
} from '@chakra-ui/react';

import { useDispatch } from 'react-redux';
import RadioItem from './RadioItem';
import { setFormSchedule, setFormScheduleMessage } from '../formSlice';

const ScheduleSetup = ({ form }) => {
  const dispatch = useDispatch();
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'schedule',
    value: form.schedule.type,
    onChange: (s) => dispatch(setFormSchedule(s)),
  });

  const handleChangeMessage = (m) => {
    dispatch(setFormScheduleMessage(m.target.value));
  };
  return (
    <Flex direction="column" minH="250px" {...getRootProps()}>
      <Accordion>
        <AccordionItem>
          <AccordionButton>
            <RadioItem
              {...getRadioProps({ value: 'always' })}
              text="Always active"
              helper="Your form is active to everybody"
            />
          </AccordionButton>

        </AccordionItem>

        <AccordionItem isDisabled>
          <AccordionButton>
            <RadioItem
              {...getRadioProps({ value: 'scheduled', isDisabled: true })}
              text="Active between"
              helper="Your form is only active between the dates and hours you set"
            />
          </AccordionButton>

        </AccordionItem>
        <AccordionItem isDisabled>
          <AccordionButton>
            <RadioItem
              {...getRadioProps({ value: 'weekdays', isDisabled: true })}
              text="Active on certain days of the week"
              helper="Your form is active on the selected days of the week"
            />
          </AccordionButton>
          <AccordionItem isDisabled>
            <AccordionButton>
              <RadioItem
                {...getRadioProps({ value: 'private', isDisabled: true })}
                text="Active only form me and my team"
                helper="The form is only visible for you and your team. Login is required"
              />
            </AccordionButton>

          </AccordionItem>
          <AccordionItem>
            <AccordionButton>
              <RadioItem
                {...getRadioProps({ value: 'never' })}
                text="Deactive form"
                helper="The form is not available to anyone"
              />
            </AccordionButton>
            <AccordionPanel py="6" bg="blackAlpha.20">
              <FormControl isRequired>
                <FormLabel>Message visible to responders</FormLabel>
                <Textarea value={form.schedule.message} onChange={handleChangeMessage} />
              </FormControl>
            </AccordionPanel>
          </AccordionItem>
        </AccordionItem>
      </Accordion>
    </Flex>
  );
};
export default ScheduleSetup;
